import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { apiUrl } from '@/api';

axios.defaults.baseURL = apiUrl;

Vue.use(VueAxios, axios)
